var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 185,
    viewBox: "0 0 1512 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40.0157L50.5101 28.315C130.635 9.7541 214.198 12.2291 293.083 35.4997L331.858 46.938C402.253 67.7038 477.386 65.8908 546.697 41.7535C617.031 17.2601 693.332 15.7634 764.573 37.4798L813.06 52.2602C870.782 69.8557 931.212 76.857 991.429 72.9254L1076.4 67.3774C1110.86 65.1276 1144.99 59.3147 1178.25 50.0315L1206.12 42.2527C1295.57 17.2847 1390.21 17.7239 1479.42 43.5208L1512 52.9403V179.781L0 185V40.0157Z",
    fill: "url(#paint0_linear_183_134)",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 73.5L103.084 48.6324C165.794 33.5044 231.463 35.9675 292.863 55.7507L324.349 65.8952C379.808 83.764 439.698 82.2134 494.158 61.4989C549.416 40.4807 610.24 39.2014 666.333 57.8774L685.844 64.3736C742.57 83.2602 803.947 82.8693 860.427 63.2617C909.805 46.1198 963.085 43.6146 1013.85 56.0477L1043.76 63.3712C1105.31 78.446 1169.97 74.7853 1229.43 52.8589C1282.45 33.3066 1339.73 28.2367 1395.36 38.171L1512 59V185H0V73.5Z",
    fill: "url(#paint1_linear_183_134)",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 37L102.986 57.4042C167.321 70.1504 233.607 69.332 297.607 55.0014C350.799 43.0907 405.654 40.496 459.734 47.3325L507.066 53.3161C549.645 58.6987 592.739 58.5769 635.287 52.9537L672.762 48.001C727.868 40.718 783.803 42.6748 838.266 53.791L845.985 55.3666C912.692 68.982 981.477 68.8307 1048.12 54.922L1059.01 52.6502C1108.71 42.2773 1159.71 39.5357 1210.24 44.52L1273.53 50.7631C1306.08 53.9741 1338.87 53.9829 1371.42 50.7896L1512 37V185H0V37Z",
    fill: "url(#paint2_linear_183_134)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_183_134",
    x1: -0.0000263623,
    y1: 83.6905,
    x2: 1512,
    y2: 83.6906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B224EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7579FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_183_134",
    x1: -0.0000263623,
    y1: 96.2857,
    x2: 1512,
    y2: 96.2858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B224EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7579FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_183_134",
    x1: -0.0000263623,
    y1: 103.952,
    x2: 1512,
    y2: 103.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B224EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7579FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBackground);
export default __webpack_public_path__ + "static/media/footerBackground.3c74013f01de79d66410722ea7cb128b.svg";
export { ForwardRef as ReactComponent };